// Chart theme configuration for PostureTrendChart

export const getChartTheme = (colors) => ({
  axis: {
    domain: {
      line: {
        stroke: colors.divider,
        strokeWidth: 1,
      },
    },
    ticks: {
      line: {
        stroke: colors.divider,
        strokeWidth: 1,
      },
      text: {
        fill: colors.grey_500,
        fontSize: 12,
        fontFamily: "Poppins",
      },
    },
  },
  grid: {
    line: {
      stroke: colors.divider,
      strokeWidth: 1,
      strokeDasharray: "",
    },
  },
  crosshair: {
    line: {
      stroke: colors.divider,
      strokeWidth: 1,
      strokeOpacity: 0.5,
      strokeDasharray: "6 6",
    },
  },
});

export const getChartConfig = (chartData) => ({
  margin: { top: 20, right: 30, bottom: 50, left: 50 },
  xScale: { type: "point" },
  yScale: {
    type: "linear",
    min: chartData.metadata?.yMin || 0,
    max: chartData.metadata?.yMax || 100,
    stacked: false,
  },
  curve: "linear",
  axisTop: null,
  axisRight: null,
  axisBottom: {
    tickSize: 0,
    tickPadding: 15,
    tickRotation: 0,
    legend: "",
    legendOffset: 36,
    legendPosition: "middle",
  },
  axisLeft: {
    tickSize: 0,
    tickPadding: 10,
    tickRotation: 0,
    tickValues: 5,
    format: (value) => `${Math.round(value)}%`,
    legend: "",
    legendOffset: -40,
    legendPosition: "middle",
  },
  enableGridX: false,
  gridYValues: 5,
  gridXValues: [],
  enableGridY: true,
  lineWidth: 2,
  pointSize: 0,
  enablePoints: false,
  enableArea: false,
  pointColor: { theme: "background" },
  pointBorderWidth: 1,
  pointBorderColor: { from: "serieColor" },
  pointLabelYOffset: -12,
  enableSlices: "x",
  useMesh: true,
  legends: [],
});
